import React from 'react';
import { Form, Input } from 'semantic';
import { useTranslation } from 'react-i18next';

import { minutesToSeconds, secondsToMinutes } from 'utils/date';
import { TariffProfileCurrentCostSettingsComponentRestrictions } from 'types/tariffprofile';

type Props = {
  restrictions: TariffProfileCurrentCostSettingsComponentRestrictions;
  disabled?: boolean;
  minDurationSeconds?: number | null;
  onMinDurationSecondsChange: (next: number | undefined) => void;
  maxDurationSeconds?: number | null;
  onMaxDurationSecondsChange: (next: number | undefined) => void;
};

export function DurationForm({
  disabled,
  minDurationSeconds,
  onMinDurationSecondsChange,
  maxDurationSeconds,
  onMaxDurationSecondsChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Form.Group>
      <Form.Field>
        <label>{t('advancedTariff.minSessionTime', 'Min session time')}</label>
        <Input
          disabled={disabled}
          type="number"
          label={t('advancedTariff.minutes', 'Minutes')}
          value={secondsToMinutes(minDurationSeconds)}
          onChange={(next) => {
            const value = minutesToSeconds(next.target.value);
            onMinDurationSecondsChange(value);
          }}
        />
      </Form.Field>
      <Form.Field>
        <label>{t('advancedTariff.maxSessionTime', 'Max session time')}</label>

        <Input
          disabled={disabled}
          type="number"
          label={t('advancedTariff.minutes', 'Minutes')}
          value={secondsToMinutes(maxDurationSeconds)}
          onChange={(next) => {
            const value = minutesToSeconds(next.target.value);
            onMaxDurationSecondsChange(value);
          }}
        />
      </Form.Field>
    </Form.Group>
  );
}
